import React, { useState } from 'react';
import IconAnimation from '@/components/BannerAI/media/AiAnimation.webp';
import MaiaIconImage from '@/media/MaiaIA/iconImage.png';
import * as Styles from './AiInitScreen.styles';
import { ACTIONS, WSS_ROUTES, SCREENS } from '../../AiChat.enum';
import { useResize } from '@/hooks/useResize';

const AiInitScreen = ({
  name,
  aichatLocale,
  inhouseFeatures,
  setCurrentScreen,
  wssToggleRoutes,
  setRoute,
  handleSubmitMerlin,
  fullScreen,
  mountForm,
}) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 960;

  const [interacted, setInteracted] = useState(false);

  const handleScroll = () => {
    setInteracted(true);
  };

  const handleSelectOption = (action, initialMessage) => {
    const rules = {
      diagnostic: () => { setRoute(wssToggleRoutes.general || WSS_ROUTES.GENERAL); },
      email: () => { setRoute(wssToggleRoutes.email || WSS_ROUTES.EMAIL); },
      domainConfig: () => { setRoute(wssToggleRoutes.domain || WSS_ROUTES.DOMAIN); },
      newSite: () => { setRoute(wssToggleRoutes.site || WSS_ROUTES.SITE); },
      whatCanItdoForYou: () => { setRoute(wssToggleRoutes.site || WSS_ROUTES.SITE); },
      marketing: () => { setRoute(wssToggleRoutes.general || WSS_ROUTES.GENERAL); },
    };

    if (rules[action]) {
      setCurrentScreen(SCREENS.CHAT_HISTORY);
      handleSubmitMerlin(initialMessage);
      return rules[action]();
    }
  };

  const renderList = () => (
    <>
      <Styles.Suggestions>
        {aichatLocale.suggestions}
      </Styles.Suggestions>

      <Styles.OptionsList
        $isFullScreen={fullScreen || isMobile}
        $interacted={interacted}
        onScroll={handleScroll}
      >
        {aichatLocale.options.map((option) => {
          if (
            (option.action === ACTIONS.DIAGNOSTIC && !inhouseFeatures.withDiagnostic)
            || (option.action === ACTIONS.EMAIL && !inhouseFeatures.withEmail)
            || (option.action === ACTIONS.DOMAIN_CONFIG && !inhouseFeatures.withDomainConfig)
            || (option.action === ACTIONS.NEW_SITE && !inhouseFeatures.withNewSite)
          ) {
            return;
          }

          return (
            <Styles.OptionItem
              onClick={() => handleSelectOption(option.action, option.initialMessage)}
              key={option.label}
              $featured={option.featured}
              $isFullScreen={fullScreen}
            >
              <option.icon color="lowDark" />

              {(fullScreen || isMobile)
                ? (
                  <Styles.FullScreenOptionItemLabel>
                    {option.label}
                  </Styles.FullScreenOptionItemLabel>
                )
                : (option.label)
              }
            </Styles.OptionItem>
          );
        })}
      </Styles.OptionsList>
    </>
  );

  const whatAiCouldDoForYouButton = () => (
    <Styles.WhatCouldItDoForYouBorder $isFullScreen={fullScreen}>
      <Styles.WhatCouldItDoForYouButton onClick={() => handleSelectOption('whatCanItdoForYou', aichatLocale.whatAiCouldDoMessage)}>
        <Styles.WhatCouldItDoForYouLabel>
          {aichatLocale.whatAiCouldDo}
        </Styles.WhatCouldItDoForYouLabel>
      </Styles.WhatCouldItDoForYouButton>
    </Styles.WhatCouldItDoForYouBorder>
  );

  if (fullScreen || isMobile) {
    return (
      <Styles.InitWrapper $isFullScreen={fullScreen} id="initWrapper">
        {isMobile && (<Styles.AnimationIcon src={MaiaIconImage || IconAnimation} />)}
        <Styles.WelcomeMessage $isFullScreen={fullScreen}>
          {!isMobile && (
            <Styles.AnimationIcon src={MaiaIconImage || IconAnimation} />
          )}
          {aichatLocale.welcome(name)}
        </Styles.WelcomeMessage>

        {!isMobile && mountForm()}

        {renderList()}

        {whatAiCouldDoForYouButton()}
      </Styles.InitWrapper>
    );
  }

  return (
    <Styles.InitWrapper id="initWrapper">
      <Styles.AnimationIcon src={MaiaIconImage || IconAnimation} />
      <Styles.WelcomeMessage>
        {aichatLocale.welcome(name)}
      </Styles.WelcomeMessage>

      {renderList()}

      {whatAiCouldDoForYouButton()}
    </Styles.InitWrapper>
  );
};

export default AiInitScreen;
